import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useLoading } from "../../../components/Loading/useLoading";
import { AddTag, CloseSalidaInventario, ReactivarEtiqueta, RemoveTagOrderOpen, UndoSalidaInventario } from "../../../hooks/ajuste";
import { HEADER_DATA_UPDATE } from "../../../redux/reducers/header.reducer";
import { useEffect, useMemo, useRef, useState } from "react";
import { Alert, Autocomplete, Box, Button, Checkbox, Chip, FormControl, Grid, TextField, Tooltip, Typography } from "@mui/material";
import { AddCircle, Close, RestartAlt, Search, Undo } from "@mui/icons-material";
import { useSnackbar } from "notistack";
import { EstatusDocumentoEnum } from "../../../@enums/status_documento.enum";
import swal from 'sweetalert2'
import { TipoDocumentoEnum } from "../../../@enums/tipo_documento";
import { AddTagMultiple, DeleteTagMultiple, GetOnlyAjuste, ProcessAll, ProcessPartial, useInfiniteItemsAjuste } from "../../../hooks/items-ajuste";
import { GetAllClientesList } from "../../../hooks/getListClientes";
import { GetAllPartesList } from "../../../hooks/getPartesList";
import moment from "moment";
import { EstatusMovimientoEnum } from "../../../@enums/status_mov_inv";


export const SalidaInventario = () => {

  const { id, almacen } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setAppLoading } = useLoading();
  const { enqueueSnackbar } = useSnackbar();
  const { getOnlyAjusteMutation } = GetOnlyAjuste();
  const { addTagMutation } = AddTag();
  const { addTagMultipleMutation } = AddTagMultiple();
  const { deleteTagMultipleMutation } = DeleteTagMultiple();
  const { closeSalidaInventarioMutation } = CloseSalidaInventario();
  const { undoSalidaInventarioMutation } = UndoSalidaInventario();
  const { reactivarEtiquetaMutation } = ReactivarEtiqueta();
  const { removeTagOrderOpenMutation } = RemoveTagOrderOpen();
  const { getAllClientesListMutation } = GetAllClientesList();
  const { getAllPartesListMutation } = GetAllPartesList();
  const { processAllMutation } = ProcessAll();
  const { processPartialMutation } = ProcessPartial();
  const [ajuste, setAjuste] = useState(null);
  const [isClosed, setIsClosed] = useState(false);
  const [filtro, setFiltro] = useState('');
  const [clientes, setClientes] = useState([]);
  const [cliente, setCliente] = useState(null);
  const [partes, setPartes] = useState([]);
  const [parte, setParte] = useState(null);
  const [filtros, setFiltros] = useState(null);
  const [tagActCheck, setTagActCheck] = useState([]);
  const [tagInCheck, setTagInCheck] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [tagExc, setTagExc] = useState([]);
  const [selectAllKeep, setSelectAllKeep] = useState([]);
  const [excAll, setExcAll] = useState([]);
  const [confirmClose, setConfirmClose] = useState(false);
  const [confirmProcess, setConfirmProcess] = useState(false);

  // -----------------------------

  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isRefetching,
    refetch,
  } = useInfiniteItemsAjuste(id, almacen, null, filtros, isClosed, tagActCheck);

  const items = useMemo(() => {
    if (!data?.pages?.length) return [];
    return data.pages.flatMap(p => p.items || []);
  }, [data]);

  const sentinelRef = useRef(null);

  useEffect(() => {
    if (!sentinelRef.current) return;

    const el = sentinelRef.current;
    const observer = new IntersectionObserver(
      (entries) => {
        const first = entries[0];
        if (first.isIntersecting && hasNextPage && !isFetchingNextPage) {
          fetchNextPage();
        }
      },
      { root: null, rootMargin: "20px", threshold: 0 }
    );

    observer.observe(el);
    return () => observer.unobserve(el);
  }, [fetchNextPage, hasNextPage, isFetchingNextPage]);
  useEffect(() => {

    if (isRefetching) {
      setAppLoading(true);
    } else {
      setAppLoading(false);
    }

  }, [isRefetching])



  // --------------------------

  useEffect(() => {
    get_ajuste();
    get_clientes();
  }, []);

  const get_ajuste = () => {
    setAppLoading(false)
    getOnlyAjusteMutation(id, {
      onSuccess: (data) => {
        if (data) {
          dispatch(
            HEADER_DATA_UPDATE({ nombreData: `Ajuste Folio ${data?.doc?.docu_folio}` })
          )
          data?.doc?.docu_estatus === EstatusDocumentoEnum.CERRADO ?
            setIsClosed(true) :
            setIsClosed(false);
          setAjuste(data);
        }
      },
      onError: (error) => {
        console.log(error)
      },
      onSettled: () => {
        setAppLoading(false);
      }
    })
  }

  //FILTRO
  const get_clientes = () => {
    getAllClientesListMutation({}, {
      onSuccess: (data) => {
        data.sort((a, b) => {
          return a.label.localeCompare(b.label);
        })
        setClientes(data)
      },
      onError: (error) => {
        console.log(error)
      }
    })
  }
  const onChangeCliente = (cliente) => {
    if (cliente) {
      setAppLoading(true);
      setCliente(cliente)
      getAllPartesListMutation(
        {},
        {
          onSuccess: (data) => {
            let parts = data.filter((part) => part.emp_id === cliente?.value);
            setPartes(parts);
          },
          onError: (error) => {
            console.log(error);
          },
          onSettled: () => {
            setAppLoading(false)
          }
        }
      );
    } else {
      setPartes([]);
      setParte(null);
      setCliente(null);
    }
  }
  const handleInputChange = (event) => {
    setFiltro(event.target.value);
  };

  //CERRAR AJUSTE
  const cerrar_ajuste = () => {
    swal.fire({
      title: "¿Esta seguro que desea realizar el ajuste del almacén?",
      text: "Se eliminarán todos los movimientos que han sido agregados en el almacén y sus respectivas masters",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, realizar ajuste"
    }).then((result) => {
      if (result.isConfirmed) {
        setAppLoading(true);
        closeSalidaInventarioMutation({ docu_id: ajuste?.doc?.docu_id, isClient: false }, {
          onSuccess: (data) => {
            console.log(data);
            setAppLoading(false);
            enqueueSnackbar(data?.mensaje, {
              autoHideDuration: 2000,
              variant: data?.success ? "success" : "error",
              anchorOrigin: {
                vertical: "top",
                horizontal: "center",
              },
            });
            navigate(`/inventarios/ajuste-inventario`);
          },
          onError: (error) => {
            console.log(error);
            setAppLoading(false);
          }
        })
      }
    })
  }
  //REACTIVAR ETIQUETA
  const delete_tag = (movdoc_id) => {
    swal.fire({
      title: "¿Esta seguro que desea reestablecer esta etiqueta del almacén?",
      text: "Aparecera de nuevo en el almacén y tendra que agregarla a una orden abierta para poder retirarla del almacén nuevamente",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, reestablecer"
    }).then((result) => {
      if (result.isConfirmed) {
        setAppLoading(true);
        reactivarEtiquetaMutation(movdoc_id, {
          onSuccess: (data) => {
            if (data?.success) {
              enqueueSnackbar('La etiqueta ha sido reactivada', {
                autoHideDuration: 2000,
                variant: "success",
                anchorOrigin: {
                  vertical: "top",
                  horizontal: "center",
                },
              });
            } else {
              enqueueSnackbar('Ha habido un problema al reactivar', {
                autoHideDuration: 2000,
                variant: "error",
                anchorOrigin: {
                  vertical: "top",
                  horizontal: "center",
                },
              });
            }
          },
          onError: (error) => {
            console.log(error);
            enqueueSnackbar('Ha habido un problema al reactivar', {
              autoHideDuration: 2000,
              variant: "error",
              anchorOrigin: {
                vertical: "top",
                horizontal: "center",
              },
            });
          },
          onSettled: () => {
            refetch();
            setAppLoading(false)
          }
        })
      }
    })

  }
  //ELIMINAR ETIQUETA ORDEN ABIERTA
  const remove_tag_open = (id) => {
    setAppLoading(true);
    removeTagOrderOpenMutation({ id, tipo: ajuste?.doc?.docu_tipo }, {
      onSuccess: (data) => {
        enqueueSnackbar(data?.mensaje, {
          autoHideDuration: 2000,
          variant: data?.success ? "success" : "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "center",
          },
        });
      },
      onError: (error) => {
        enqueueSnackbar("Hubo un error al procesar", {
          autoHideDuration: 2000,
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "center",
          },
        });
      },
      onSettled: () => {
        refetch();
        setAppLoading(false);
      }
    })
  }
  //ELIMINAR SALIDA COMPLETA
  const undo_salida = () => {
    swal.fire({
      title: "¿Esta seguro que desea reestablecer todas las etiquetas de esta salida?",
      text: "Aparecerán de nuevo en el almacén y tendrá que agregarlas a una orden abierta para poder retirarlas del almacén nuevamente",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, reestablecer"
    }).then((result) => {
      if (result.isConfirmed) {
        setAppLoading(true);
        undoSalidaInventarioMutation(ajuste?.doc?.docu_id, {
          onSuccess: (data) => {
            console.log(data);
            if (data?.success) {
              enqueueSnackbar('Las etiquetas han sido reactivadas', {
                autoHideDuration: 2000,
                variant: "success",
                anchorOrigin: {
                  vertical: "top",
                  horizontal: "center",
                },
              });
            } else {
              enqueueSnackbar('Ha habido un problema al reactivar', {
                autoHideDuration: 2000,
                variant: "error",
                anchorOrigin: {
                  vertical: "top",
                  horizontal: "center",
                },
              });
            }
            setAppLoading(false);
            navigate(`/inventarios/ajuste-inventario`);
          },
          onError: (error) => {
            console.log(error);
            setAppLoading(false);
            enqueueSnackbar('Ha habido un problema al reactivar', {
              autoHideDuration: 2000,
              variant: "error",
              anchorOrigin: {
                vertical: "top",
                horizontal: "center",
              },
            });
          }
        })
      }
    })
  }
  //AGREGAR ETIQUETA DIRECTAMENTE
  const add_tag = (tag) => {
    swal.fire({
      title: "¿Esta seguro que desea agregar esta etiqueta a la salida?",
      text: "Desaparecerá del almacén y se eliminará al cerrar la salida",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, agregar"
    }).then((result) => {
      if (result.isConfirmed) {
        setAppLoading(true);
        addTagMutation({ tag, docu_tipo: TipoDocumentoEnum.SALIDA_ALMACEN, isCliente: false, emp_id: null }, {
          onSuccess: (data) => {
            enqueueSnackbar(data?.mensaje, {
              autoHideDuration: 2000,
              variant: data?.success ? "success" : "error",
              anchorOrigin: {
                vertical: "top",
                horizontal: "center",
              },
            });
          },
          onError: (error) => {
            enqueueSnackbar("Hubo un error al procesar, inténtelo nuevamente", {
              autoHideDuration: 2000,
              variant: "error",
              anchorOrigin: {
                vertical: "top",
                horizontal: "center",
              },
            });
          },
          onSettled: () => {
            refetch();
            setAppLoading(false);
          }
        })
      }
    })
  }

  const procesarMultiple = () => {
    if (selectAll) {
      process_all();
    } else if (selectAllKeep.length > 0) {
      process_partial();
    }
    else {
      if (tagActCheck.length > 0) add_tag_multi();
      if (tagInCheck.length > 0) delete_tag_multi();
    }
    setTagActCheck([]);
    setTagInCheck([]);
    setTagExc([]);
    setSelectAllKeep([]);
    setExcAll([]);
    setSelectAll(false);
    setConfirmProcess(false);
    setConfirmClose(false);
  }
  const add_tag_multi = () => {
    swal.fire({
      title: "¿Esta seguro que desea procesar todas estas etiquetas?",
      text: "Desaparecerán del almacén y se eliminarán al cerrar la salida",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, agregar"
    }).then((result) => {
      if (result.isConfirmed) {
        setAppLoading(true);
        addTagMultipleMutation({ tag: tagActCheck, docu_tipo: TipoDocumentoEnum.SALIDA_ALMACEN }, {
          onSuccess: (data) => {
            enqueueSnackbar(data?.mensaje, {
              autoHideDuration: 2000,
              variant: data?.success ? "success" : "error",
              anchorOrigin: {
                vertical: "top",
                horizontal: "center",
              },
            });
          },
          onError: (error) => {
            enqueueSnackbar("Hubo un error al procesar, inténtelo nuevamente", {
              autoHideDuration: 2000,
              variant: "error",
              anchorOrigin: {
                vertical: "top",
                horizontal: "center",
              },
            });
          },
          onSettled: () => {
            refetch();
            setAppLoading(false);
          }
        })
      }
    })
  }
  const delete_tag_multi = () => {
    swal.fire({
      title: "¿Esta seguro que desea procesar todas estas etiquetas?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, agregar"
    }).then((result) => {
      if (result.isConfirmed) {
        setAppLoading(true);
        deleteTagMultipleMutation({ domo_id: tagInCheck, isCliente: false }, {
          onSuccess: (data) => {
            enqueueSnackbar(data?.mensaje, {
              autoHideDuration: 2000,
              variant: data?.success ? "success" : "error",
              anchorOrigin: {
                vertical: "top",
                horizontal: "center",
              },
            });
          },
          onError: (error) => {
            enqueueSnackbar("Hubo un error al procesar, inténtelo nuevamente", {
              autoHideDuration: 2000,
              variant: "error",
              anchorOrigin: {
                vertical: "top",
                horizontal: "center",
              },
            });
          },
          onSettled: () => {
            refetch();
            setAppLoading(false);
          }
        })
      }
    })
  }
  const process_all = () => {
    setAppLoading(true)
    let data_f = {}
    if (parte) data_f.part_id = parte?.value;
    if (cliente) data_f.emp_id = cliente?.value;
    let emp_exc = [];
    let part_exc = [];
    let part_keep = [];
    for (let exc of excAll) {
      if (exc?.partes.length > 0) {
        part_exc = [...part_exc, ...exc?.partes];
      } else {
        emp_exc.push(exc?.emp_id);
      }
      if (exc?.partes_keep.length > 0) {
        part_keep = [...part_keep, ...exc?.partes_keep];
      }
    }
    console.log(emp_exc, part_exc, part_keep, tagExc)
    processAllMutation({ alma_id: almacen, tagExc, emp_exc, part_exc, part_keep, docu_tipo: TipoDocumentoEnum.SALIDA_ALMACEN }, {
      onSuccess: (data) => {
        enqueueSnackbar("Datos procesados con exito", {
          autoHideDuration: 2000,
          variant: data?.success ? "success" : "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "center",
          },
        });
      },
      onError: (error) => {
        console.log(error)
      },
      onSettled: () => {
        refetch();
        setAppLoading(false)
      }
    })

  }
  const process_partial = () => {
    setAppLoading(true)
    let emp_keep = [];
    let part_exc = [];
    let part_keep = [];
    for (let exc of selectAllKeep) {
      if (exc?.partes.length > 0) {
        part_keep = [...part_keep, ...exc?.partes];
      } else {
        emp_keep.push(exc?.emp_id);
      }
      if (exc?.partes_exc.length > 0) {
        part_exc = [...part_exc, ...exc?.partes_exc];
      }
    }
    console.log(emp_keep, part_exc, part_keep, tagExc)
    processPartialMutation({ alma_id: almacen, tagExc, emp_keep, part_exc, part_keep, docu_tipo: TipoDocumentoEnum.SALIDA_ALMACEN }, {
      onSuccess: (data) => {
        enqueueSnackbar("Datos procesados con exito", {
          autoHideDuration: 2000,
          variant: data?.success ? "success" : "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "center",
          },
        });
      },
      onError: (error) => {
        console.log(error)
      },
      onSettled: () => {
        refetch();
        setAppLoading(false)
      }
    })

  }

  const aplica_filtro = () => {

    let data_f = {}

    if (parte) data_f.parte = parte;
    if (cliente) data_f.cliente = cliente
    if (filtro && filtro !== '') data_f.tag = filtro

    if (Object.keys(data_f).length > 0) {
      setFiltros(data_f);
      refetch();
    }
    setConfirmProcess(false);
    setConfirmClose(false);
  }
  const reset_filtros = () => {
    setCliente(null);
    setParte(null);
    setFiltros(null);
  }
  const checkedTag = (mov, act, e) => {
    setConfirmProcess(false);
    setConfirmClose(false);
    if ((selectAll && !act) || (!selectAll && !act && selectAllKeep.length > 0) || (!selectAll && !act && excAll.length > 0)) {
      let check = e.target.checked;
      console.log(check, mov?.tag)
      if (check) {
        setTagExc((prev) => prev.filter((t) => t !== mov?.tag))
      } else {
        setTagExc((prev) => [...prev, mov?.tag]);
      }
      console.log(tagExc)
    } else if (act) {
      let exist = tagInCheck.indexOf(mov?.domo_id);
      if (exist === -1) {
        setTagInCheck((prev) => [...prev, mov?.domo_id]);
      } else {
        setTagInCheck((prev) => prev.filter((_, index) => index !== exist));
      }
    } else {
      let exist = tagActCheck.indexOf(mov?.tag);
      if (exist === -1) {
        setTagActCheck((prev) => [...prev, mov?.tag]);
      } else {
        setTagActCheck((prev) => prev.filter((_, index) => index !== exist));
      }
    }
  }

  const selectAllOnlyKeep = () => {
    if (filtros && !selectAll) {
      let exist = selectAllKeep.findIndex((f) => f?.emp_id === filtros?.cliente?.value);
      if (exist === -1) {
        let new_keep = {
          emp_id: filtros?.cliente?.value,
          partes: [],
          partes_exc: []
        }
        if (filtros?.parte) {
          new_keep.partes.push(filtros?.parte?.value);
        }
        setSelectAllKeep((prev) => [...prev, new_keep]);
      } else {
        let list_keep = [...selectAllKeep];

        if (filtros?.parte) {
          if (list_keep[exist].partes.length === 0) {
            let inc_exc = list_keep[exist].partes_exc.indexOf(filtros?.parte?.value);
            if (inc_exc === -1) {
              list_keep[exist].partes_exc.push(filtros?.parte?.value);
            } else {
              list_keep[exist].partes_exc = list_keep[exist].partes_exc.filter((_, index) => index !== inc_exc);
            }
          } else {
            let inc = list_keep[exist].partes.indexOf(filtros?.parte?.value);
            if (inc === -1) {
              list_keep[exist].partes.push(filtros?.parte?.value);
            } else {
              list_keep[exist].partes = list_keep[exist].partes.filter((_, index) => index !== inc);
            }
          }
        } else {
          if (list_keep[exist].partes.length > 0) {
            list_keep[exist].partes = [];
          } else {
            list_keep.filter((_, index) => index !== exist);
          }
        }

        setSelectAllKeep((prev) => [...list_keep]);
      }
    } else if (filtros && selectAll) {
      let exist = excAll.findIndex((f) => f?.emp_id === filtros?.cliente?.value);
      if (exist === -1) {
        let new_exc = {
          emp_id: filtros?.cliente?.value,
          partes: [],
          partes_keep: [],
        }
        if (filtros?.parte) {
          new_exc.partes.push(filtros?.parte?.value);
        }
        setExcAll((prev) => [...prev, new_exc]);
      } else {
        let list_exc = [...excAll];
        let total_partes = list_exc[exist].partes.length;
        if (filtros?.parte) {
          if (list_exc[exist].partes.length === 0) {
            let inc_exc = list_exc[exist].partes_keep.indexOf(filtros?.parte?.value);
            if (inc_exc === -1) {
              list_exc[exist].partes_keep.push(filtros?.parte?.value);
            } else {
              list_exc[exist].partes_keep = list_exc[exist].partes_keep.filter((_, index) => index !== inc_exc);
            }
          } else {
            let inc_exc = list_exc[exist].partes.indexOf(filtros?.parte?.value);
            if (inc_exc === -1) {
              list_exc[exist].partes.push(filtros?.parte?.value);
            } else {
              list_exc[exist].partes = list_exc[exist].partes.filter((_, index) => index !== inc_exc);
              if (total_partes === 1) {
                list_exc = list_exc.filter((_, index) => index !== exist);
              }
            }
          }

        } else {
          if (list_exc[exist].partes.length > 0) {
            list_exc[exist].partes = [];
          } else {
            list_exc.filter((_, index) => index !== exist);
          }
        }
        setExcAll((prev) => [...list_exc]);
      }
    }
    else {
      if (selectAll) {
        setTagExc([]);
      }
      setSelectAllKeep([]);
      setExcAll([]);
      setTagActCheck([]);
      setSelectAll(!selectAll)
    }
  }

  const isChecked = (mov) => {
    if (tagActCheck.some(t => t === mov?.tag)) {
      console.log(1)
      return true
    };
    if (tagInCheck.some(t => t === mov?.domo_id)) {
      console.log(2)
      return true
    };
    if (selectAll && !mov?.fromDocMov && excAll.some(f => f?.emp_id === mov?.emp_id && f?.partes_keep.includes(mov?.part_id))) {
      console.log(4)
      return true
    };
    if (!selectAll && !mov?.fromDocMov && tagExc.some(t => t === mov?.tag)) {
      console.log(3.5)
      return false
    };
    if (selectAll && !mov?.fromDocMov && excAll.some(f => f?.emp_id === mov?.emp_id && f?.partes.includes(mov?.part_id))) return false;
    if (selectAll && !mov?.fromDocMov && excAll.some(f => f?.emp_id === mov?.emp_id && f?.partes.length === 0)) return false;
    if (!selectAll && !mov?.fromDocMov && selectAllKeep.some(f => f?.emp_id === mov?.emp_id && (f?.partes.length === 0 || f?.partes.includes(mov?.part_id)) && !f?.partes_exc.includes(mov?.part_id))) {
      console.log(5)
      return true
    };
    if (selectAll && !mov?.fromDocMov && !tagExc.some(t => t === mov?.tag)) {
      console.log(3)
      return true
    };

    return false
  }

  const confirmCloseAjuste = () => {
    reset_filtros();
    setConfirmClose(true);
  }

  return (
    <>
      {
        (
          <Grid container spacing={0}>
            <Grid item xs={12} sx={{ p: 1, textAlign: 'start', display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, p: 1 }}>
              <Typography id="transition-modal-title" variant="h5" component="h2">
                {/* {`${JSON.parse(ajuste?.doc?.docu_extradata)?.almacen?.toUpperCase()}`} */}
              </Typography>
              {isClosed ?
                (
                  <Button variant="contained" className="btn_system" sx={{ width: 200, ml: 1 }} onClick={undo_salida}>
                    Reestablecer Ajuste
                  </Button>
                ) :
                (
                  <>
                    {
                      confirmClose ?
                        <Button variant="contained" className="btn_system" sx={{ width: 200, ml: 1 }} onClick={cerrar_ajuste}>
                          Confirmar cierre
                        </Button> :
                        <Button variant="contained" className="btn_system" sx={{ width: 200, ml: 1 }} onClick={confirmCloseAjuste}>
                          Cerrar Ajuste
                        </Button>

                    }
                  </>
                )
              }
            </Grid>
            <Grid item xs={12} sx={{ p: 1, textAlign: 'start', display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, p: 1 }}>
              <Grid container spacing={0}>
                <Grid item xs={3} sx={{ display: 'flex', alignItems: 'center', p: 1 }}>
                  <FormControl fullWidth size="small">
                    <Autocomplete
                      fullWidth
                      id="emp_id"
                      getOptionLabel={(opcion) => opcion.label}
                      filterSelectedOptions
                      options={clientes}
                      value={cliente}
                      onChange={(e, newValue) => {
                        onChangeCliente(newValue)
                      }}
                      renderOption={(props, option) => (
                        <Box {...props} key={option?.value}>{option.label}</Box>
                      )}
                      renderInput={(params) =>
                        <TextField {...params} label="Cliente" size="small" fullWidth required />
                      }
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={2} sx={{ display: 'flex', alignItems: 'center', p: 1 }}>
                  <FormControl fullWidth size="small">
                    <Autocomplete
                      fullWidth
                      id="part_id"
                      getOptionLabel={(opcion) =>
                        opcion?.codigo !== undefined ?
                          `${opcion?.label} / ${opcion?.codigo} / ${opcion?.codigo_salida} / ${opcion?.codigo_alterno}` :
                          opcion?.label
                      }
                      filterSelectedOptions
                      options={partes}
                      onChange={(e, newValue) => {
                        if (newValue === null) {
                          setParte(null)
                        } else {
                          setParte(newValue)
                        }
                      }}
                      renderOption={(props, option) => (
                        <Box {...props} key={option?.value}>
                          {option?.codigo !== undefined ? option?.codigo : <></>} /
                          {option?.codigo_salida !== undefined ? option?.codigo_salida : <></>} /
                          {option?.codigo_alterno !== undefined ? option?.codigo_alterno : <></>} / {option?.label}
                        </Box>
                      )}
                      value={parte}
                      renderInput={(params) =>
                        <TextField {...params} label="Parte" size="small" fullWidth required />
                      }
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={2} sx={{ display: 'flex', alignItems: 'center', p: 1 }}>
                  <TextField
                    id="search_data"
                    label="Etiqueta"
                    name="search_data"
                    size="small"
                    value={filtro}
                    onChange={handleInputChange}
                  />
                </Grid>
                <Grid item xs={1} sx={{ display: 'flex', alignItems: 'center', p: 1 }}>
                  <Tooltip title="Aplicar filtro" placement="right">
                    <Button variant="contained" className="btn_system" onClick={aplica_filtro} sx={{ width: 40, minWidth: 30, ml: 1 }} >
                      <Search />
                    </Button>
                  </Tooltip>
                  {
                    filtros &&
                    <Tooltip title="Restaurar filtro" placement="right">
                      <Button variant="contained" className="btn_system" onClick={reset_filtros} sx={{ width: 40, minWidth: 30, ml: 1, backgroundColor: '#E0D528' }} >
                        <RestartAlt />
                      </Button>
                    </Tooltip>
                  }
                </Grid>
              </Grid>
            </Grid>
            {
              !isClosed &&
              <Grid item xs={12} sx={{ p: 1, textAlign: 'start', display: 'flex', justifyContent: 'flex-end', alignItems: 'center', mb: 2, p: 1 }}>
                <Grid item xs={2} sx={{ display: 'flex', alignItems: 'center', p: 1 }}>
                  {
                    confirmProcess ?
                      <Tooltip title="Procesar" placement="right">
                        <Button variant="contained" className="btn_system" onClick={procesarMultiple} disabled={tagActCheck.length === 0 && tagInCheck.length === 0 && !selectAll && selectAllKeep.length === 0} sx={{ ml: 1 }} >
                          Confirmar proceso
                        </Button>
                      </Tooltip> :
                      <Tooltip title="Procesar" placement="right">
                        <Button variant="contained" className="btn_system" onClick={() => {
                          reset_filtros();
                          setConfirmProcess(true);
                        }} disabled={tagActCheck.length === 0 && tagInCheck.length === 0 && !selectAll && selectAllKeep.length === 0} sx={{ ml: 1 }} >
                          Procesar datos
                        </Button>
                      </Tooltip>
                  }
                </Grid>
                <Grid item xs={2} sx={{ display: 'flex', alignItems: 'center', p: 1 }}>
                  <Tooltip title={`${selectAll ? "Deseleccionar" : "Seleccionar"} todos`} placement="right">
                    <Button
                      variant="contained"
                      className="btn_system"
                      onClick={selectAllOnlyKeep}
                      sx={{ ml: 1 }}
                    >
                      {`${selectAll ? "Deseleccionar" : "Seleccionar"} todos`}
                    </Button>
                  </Tooltip>
                </Grid>
              </Grid>
            }
            {
              confirmClose &&
              <Alert severity="info" variant="outlined" sx={{ width: '100%', mb: 1, p: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                Para cerrar el ajuste, es necesario confirmar, rectifique que no haya etiquetas pendientes de procesar.
                Lo resaltado en <span style={{ color: 'rgb(150, 1, 1)', fontWeight: 600 }}>Rojo</span> se eliminará del almacen y
                lo resaltado en <span style={{ color: '#575E3B', fontWeight: 600 }}>Verde</span> se mantendrá.
              </Alert>
            }
            {
              confirmProcess &&
              <Alert severity="info" variant="outlined" sx={{ width: '100%', mb: 1, p: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                Todo lo marcado por los checkboxes se procesará, confirme si desea continuar.
              </Alert>
            }
            <Grid item xs={12} sx={{ p: 1, textAlign: 'start', display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
              <Grid container spacing={0} sx={{ border: "1px solid #D9D9D9", borderRadius: 5, mb: 3, p: 1, display: 'flex' }}>
                <Grid item xs={12} className="container_split" >
                  <Grid
                    container
                    spacing={0}
                    sx={{
                      p: 1,
                      textAlign: "start",
                      display: "flex",
                      alignItems: "center",
                      border: '1px solid #D9D9D9',
                      borderRadius: 2,
                      width: 'auto'
                    }}
                  >
                    {
                      items.map((mov, index) => (
                        <Grid
                          item
                          xs={6}
                          sm={6}
                          md={4}
                          lg={3}
                          xl={3}
                          sx={{
                            p: 1,
                            textAlign: "start",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <Chip
                            label={
                              <>
                                {
                                  !isClosed &&
                                  <div
                                    style={{
                                      backgroundColor: "transparent",
                                      display: "flex",
                                      alignItems: 'center',
                                      justifyContent: 'flex-end',
                                      width: '100%',
                                      maxWidth: '100%',
                                      marginLeft: 20
                                    }}
                                  >
                                    <Checkbox
                                      checked={isChecked(mov)}
                                      disabled={(selectAll && mov?.fromDocMov) || (mov?.fromDocMov && tagActCheck.length > 0) || (!mov?.fromDocMov && tagInCheck.length > 0)}
                                      onChange={(e) => checkedTag(mov, mov?.fromDocMov, e)}
                                    />
                                  </div>
                                }
                                <div
                                  style={{
                                    backgroundColor: "transparent",
                                    border: "none",
                                    display: "flex",
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: '100%',
                                    maxWidth: '100%'
                                  }}
                                >
                                  <span
                                    style={{
                                      marginRight: 7,
                                      fontSize: 14,
                                      fontWeight: 400,
                                      color: "black",
                                    }}
                                  >
                                    {mov?.quantity}
                                  </span>
                                  <span
                                    style={{
                                      marginLeft: 7,
                                      border: mov?.fromDocMov ? "1px solid rgb(150, 1, 1)" : "1px solid #575E3B",
                                      borderRadius: 4,
                                      fontSize: 11,
                                      padding: 3,
                                      color: mov?.fromDocMov ? "rgb(170, 0, 0)" : "#575E3B"
                                    }}
                                  >
                                    {mov?.tag}
                                  </span>
                                </div>
                                <div
                                  style={{
                                    backgroundColor: "transparent",
                                    border: "none",
                                    width: '100%',
                                    maxWidth: '100%',
                                    textAlign: 'center'
                                  }}
                                >
                                  <span
                                    style={{
                                      marginLeft: 7,
                                      fontSize: 15,
                                      padding: 3,
                                      color: "black"
                                    }}
                                  >
                                    {`${mov?.name}`}
                                  </span>
                                  <br />
                                  <span
                                    style={{
                                      marginLeft: 7,
                                      fontSize: 15,
                                      padding: 3,
                                      color: "black"
                                    }}
                                  >
                                    {`${mov?.code}`}
                                  </span>
                                  <br />
                                  <span
                                    style={{
                                      marginLeft: 7,
                                      fontSize: 15,
                                      padding: 3,
                                      color: "black"
                                    }}
                                  >
                                    {`${mov?.empresa}`}
                                  </span>
                                  <br />
                                  <span
                                    style={{
                                      marginLeft: 7,
                                      border: mov?.fromDocMov ? "1px solid rgb(150, 1, 1)" : "1px solid #575E3B",
                                      borderRadius: 4,
                                      fontSize: 11,
                                      padding: 3,
                                      color: mov?.fromDocMov ? "rgb(170, 0, 0)" : "#575E3B"
                                    }}
                                  >
                                    {
                                      mov?.status === EstatusMovimientoEnum.CARGADO || mov?.prevStatus === EstatusMovimientoEnum.CARGADO ?
                                        "Cargado" :
                                        "Pie de línea"
                                    }
                                  </span>
                                  <br />
                                  <span
                                    style={{
                                      marginLeft: 7,
                                      fontSize: 15,
                                      padding: 3,
                                      color: "black"
                                    }}
                                  >
                                    {`${moment(mov?.fecha).format('DD-MM-YYYY')}`}
                                  </span>
                                </div>
                              </>
                            }
                            variant="outlined"
                            deleteIcon={
                              mov?.fromDocMov ?
                                <Undo sx={{ marginLeft: "1px !important" }} />
                                : <AddCircle sx={{ marginLeft: "1px !important" }} />
                            }
                            onDelete={
                              () => isClosed ? delete_tag(mov?.domo_id) :
                                mov?.fromDocMov ? remove_tag_open(mov?.domo_id) : add_tag(mov?.tag)
                            }
                            sx={{
                              height: 'auto',
                              padding: isClosed ? '10px 0' : '2px 0',
                              borderRadius: 2,
                              display: "flex",
                              alignItems: 'center',
                              width: "100%",
                              maxWidth: '100%',
                              backgroundColor: "transparent",
                              border: mov?.fromDocMov ? "1px solid rgb(150, 1, 1)" : "-moz-initial"
                            }}
                          />
                        </Grid>
                      ))
                    }
                    <div ref={sentinelRef} style={{ height: 1 }} />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        )
      }
    </>
  )
}